<style scoped>
.arrow-down {
    transform: rotate(180deg);
}
</style>

<template>
    <div class="border border-gray-100 rounded mt-2">
        <div
            class="p-2 flex text-gray-600 font-bold text-lg leading-normal cursor-pointer"
            @click="show = !show"
        >
            <div>{{ title }}</div>
            <button
                class="icon ml-auto focus:outline-none focus:text-darkGrayishBlue"
                :class="{ 'arrow-down': !show }"
            >
                <triangleUpSvg />
            </button>
        </div>
        <div v-show="show" class="p-2 leading-normal text-base">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import triangleUpSvg from '@/assets/svg/triangleUp.svg';
export default {
    components: { triangleUpSvg },
    props: { title: { type: String } },
    data() {
        return { show: false };
    },
    methods: {
        toggle(show) {
            this.show = show;
        }
    }
};
</script>
